import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { NectarTheme } from "@nectarTypes";

export const CardWrapper = styled.div`
  ${({ theme }: NectarTheme) => css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.md};
  `}
`;

export const StatsContainer = styled.div`
  ${({ theme }: NectarTheme) => css`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: ${theme.spacings.lg};

    ${theme.breakpoints.sm} {
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-template-rows: 1fr;
    }

    ${theme.breakpoints.lg} {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr;
    }
  `}
`;

export const ItemContainer = styled.div`
  ${({ _theme }: NectarTheme) => css`
    flex-grow: 1;
  `}
`;
